import { BaseService, Service } from "/@/cool";

@Service("buyTypeCate")
class BuyTypeCate extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["list"] = prefix + "list";
		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["info"] = prefix + "info";
		this.permission["delete"] = prefix + "delete";
	}
}

export default BuyTypeCate;
